import React from 'react';
import AppImage from '@/components/ui/AppImage';

interface HeroImageProps {
  src: string;
  alt: string;
}

export default function HeroImage({ src, alt }: HeroImageProps) {
  return (
    <div className="absolute inset-0 z-0">
      <AppImage
        src={src}
        alt={alt}
        className="w-full h-full object-cover object-center scale-100 sm:scale-105"
        priority
      />
      <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 sm:from-slate-900/80 via-slate-900/40 sm:via-slate-900/30 to-transparent" />
    </div>
  );
}